export enum QuestionOption {
  Yes = 'Yes',
  No = 'No',
  IDontKnow = 'I don\'t know',
  RarelyOrNever = '1',
  Sometimes = '2',
  Often = '3',
  Usually = '4',
  AlmostAlways = '5'
}
